import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { InputConfig } from 'src/gameSchemas/types'

const TextFormGroup = (props: {
  formId: string
  inputConfig: InputConfig
  onChange: (value: string) => void
  value: string
}) => (
  <Form.Group as={Row} controlId={props.formId}>
    <Form.Label column sm="2">
      {props.inputConfig.label}
    </Form.Label>
    <Col sm="10">
      <Form.Control
        placeholder="Type here"
        onChange={(e: React.ChangeEvent<any>) => {
          props.onChange(e.target.value)
        }}
        value={props.value}
        name={props.formId}
      />
    </Col>
  </Form.Group>
)

export default TextFormGroup
